{
  "title": "受信箱",
  "totalBadge": "{{count}} 件",
  "viewAll": "すべて見る",
  "loading": "読み込み中…",
  "emptySection": "すべて対応済み",
  "loadError": "このセクションを読み込めませんでした"
}
